import { useTownConfig } from '../../stores';
import { config, usePrivileges } from '../../utils';

function SettingsPageSubmenu({ renderItems, translate }) {
  const { hasAnyPrivilege } = usePrivileges();
  const isAdmin = hasAnyPrivilege(['admin']);

  const { townConfig } = useTownConfig();
  const isTown = townConfig?.cstmrType === 'town';

  const items = [
    { label: translate('customization'), link: 'custom' },
    {
      label: translate('plans'),
      link: 'plans',
      hide: (!(config.dev || config.demo)),
    },
    { label: translate('licenses'), link: 'licenses' },
    { label: translate('files'), link: 'files' },
  ];

  if (isTown) {
    items.push(
      { label: translate('zones'), link: 'zones' },
    );
  }

  items.push(
    // { label: translate('integrations'), link: 'integrations', hide: true },
    { label: translate('global'), link: 'global', hide: (!isAdmin) },
  );

  return renderItems(items);
}

export default SettingsPageSubmenu;
